import { encodeStorage } from "functions/storageBase64"
import { useEffect, useState } from "react"

export function useWebview(){
    const [typeNav, setTypeNav] = useState()
    const [typeMovile, setTtypeMovile] = useState(null)

    useEffect(()=>{
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            if( ( /Mac OS X/i.test(navigator.userAgent) && !/Safari/i.test(navigator.userAgent) ) ){
                setTypeNav('app')
                encodeStorage('isMobile','app')
                document.querySelector('#root').classList.add('webviewApp')
            }else{
                setTypeNav('desktop')
                encodeStorage('isMobile','desktop')
            }

            if( /Mac OS X/i.test(navigator.userAgent) && window.navigator.maxTouchPoints >= 1 ){
                setTypeNav('app')
                encodeStorage('isMobile','app')
                setTtypeMovile('iOS')
                document.querySelector('#root').classList.add('webviewApp')
            }

        }else{
            if(navigator.userAgent.indexOf('wv') !==  -1){
                setTypeNav('app')
                encodeStorage('isMobile','app')
                document.querySelector('#root').classList.add('webviewApp')
            }else if(navigator.userAgent.indexOf('Version') ===  -1){
                if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){
                    setTypeNav('app')
                    encodeStorage('isMobile','app')
                    document.querySelector('#root').classList.add('webviewApp')
                }
            }
            else{
                // console.log('movil')
                setTypeNav('movil')
                encodeStorage('isMobile','movil')
            }
        }
        if(/Android/i.test(navigator.userAgent)){
            setTtypeMovile('android')
        }else if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){
            setTtypeMovile('iOS')
        }
    },[])

    return{
        typeNav, typeMovile
    }
}